export default "__VITE_ASSET__kskvpHeE__"